import React, { useEffect } from "react";

// Import your components

import Landiningpage from "./Landiningpage";  
import Homegeleery from "./Homegeleery";
import Maamaasbanner from "./Maamaasbanner";
import Ourstack from "./Ourstack";
import Maamaasbusiness from "./Maamaasbusiness";
import Digitalpresence from "./Digitalpresence";
const Login = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div  style={{scrollbarWidth:'none'}}>

      <Landiningpage />
      {/* <Ourstack/> */}
      <Digitalpresence/>
      <Maamaasbusiness/>
      {/* <Maamaasbanner /> */}
      
       <Homegeleery />
    
    </div>
  );
};

export default Login;